<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FPiTCm/tc-custom/9781467446198.jpg?1728851792828" alt="This image is the cover for the book Canonical Theology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Canonical Theology
      </h1>
      <p class="bookDescription body article font2">
        <p>What are the roles of canon and community in the understanding and articulation of Christian doctrine? Should the church be the doctrinal arbiter in the twenty-first century? In <i>Canonical Theology</i> John Peckham tackles this complex, ongoing discussion by shedding light on issues surrounding the biblical canon and the role of the community for theology and practice.<br/><br/> Peckham examines the nature of the biblical canon, the proper relationship of Scripture and tradition, and the interpretation and application of Scripture for theology. He lays out a compelling canonical approach to systematic theology — including an explanation of his method, a step-by-step account of how to practice it, and an example of what theology derived from this canonical approach looks like.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Peckham, Craig G. Bartholomew
      </h2>
      
      <p class="authorDescription body article"><B>John C. Peckham </B>is associate professor of theology and Christian philosophy at the Theological Seminary of Andrews University, Berrien Springs, Michigan. He is also the author of <I>The Love of&#160;God: A&#160;Canonical Model.</I><BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?409903c4